"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ShortcutBase_1 = require("./ShortcutBase");

var shortcuts_1 = require("../../../models/query/scenarioStatistics/shortcuts");

var scenarioStatistics_1 = require("../../../models/query/scenarioStatistics");

var utils_1 = require("../../../utils");

var PortfoliosBarChartDataShortcut =
/** @class */
function (_super) {
  __extends(PortfoliosBarChartDataShortcut, _super);

  function PortfoliosBarChartDataShortcut(scenarioStatisticQuery) {
    var _this = _super.call(this, scenarioStatistics_1.ScenarioStatisticShortcut.portfoliosBarChartData, shortcuts_1.ShortcutType.rootOptions, scenarioStatisticQuery) || this;

    _this.getLabels = function (rawOverrides) {
      if (rawOverrides === void 0) {
        rawOverrides = {};
      }

      var overrides = __assign({}, rawOverrides);

      var response = {
        periodAll: 'ALL',
        periodMonth: '{value}M',
        periodYear: '{value}Y',
        periodMonths: '{value}M',
        periodYears: '{value}Y'
      };

      if (overrides.periodMonths && !overrides.periodMonth) {
        overrides.periodMonth = overrides.periodMonths;
      }

      if (overrides.periodYears && !overrides.periodYear) {
        overrides.periodYear = overrides.periodYears;
      }

      Object.assign(response, overrides);
      return response;
    };

    return _this;
  }

  PortfoliosBarChartDataShortcut.prototype.getRootOptions = function (shortcutOptions) {
    var _a = shortcutOptions.options,
        options = _a === void 0 ? {} : _a,
        _b = shortcutOptions.periods,
        periods = _b === void 0 ? {} : _b,
        _c = shortcutOptions.portfolios,
        portfolios = _c === void 0 ? {} : _c;

    var workingShortcutOptions = __assign({}, shortcutOptions);

    if (!workingShortcutOptions.periods) {
      workingShortcutOptions.periods = {};
    }

    workingShortcutOptions.periods.target = scenarioStatistics_1.ScenarioStatisticTarget.collection;

    if (!workingShortcutOptions.periods.collectionOptions) {
      workingShortcutOptions.periods.collectionOptions = {};
    }

    var _d = options.portfoliosBarChartData || {},
        data = _d.data,
        rawLabels = _d.labels;

    var labels = this.getLabels(rawLabels);
    workingShortcutOptions.periods.collectionOptions.injectId = {
      enabled: true,
      transform: {
        key: {
          staticValue: 'period'
        },
        value: {
          transforms: [{
            transformOptionsType: 'alias',
            aliases: [{
              source: 'all',
              replacement: labels.periodAll
            }]
          }]
        }
      }
    }; // Add aliases for the first 11 months

    for (var i = 1; i <= 11; i++) {
      workingShortcutOptions.periods.collectionOptions.injectId.transform.value.transforms[0].aliases.push({
        source: i.toString(),
        replacement: utils_1.replacePlaceholders({
          value: i
        }, labels.periodMonth),
        fullMatchOnly: true
      });
    } // Add aliases for 30 years


    for (var i = 1; i <= 30; i++) {
      workingShortcutOptions.periods.collectionOptions.injectId.transform.value.transforms[0].aliases.push({
        source: (i * 12).toString(),
        replacement: utils_1.replacePlaceholders({
          value: i
        }, labels.periodYear),
        fullMatchOnly: true
      });
    }

    if (!workingShortcutOptions.portfolios) {
      workingShortcutOptions.portfolios = {};
    }

    workingShortcutOptions.portfolios.target = scenarioStatistics_1.ScenarioStatisticTarget.collection;

    if (!workingShortcutOptions.portfolios.collectionOptions) {
      workingShortcutOptions.portfolios.collectionOptions = {};
    }

    workingShortcutOptions.portfolios.collectionOptions.pivotToObject = {
      enabled: true,
      transform: {
        key: {
          prefix: 'portfolio'
        }
      }
    };
    var response = this.scenarioStatisticQuery.shortcuts.portfolios.getRootOptions(__assign(__assign({}, workingShortcutOptions), {
      options: {
        portfolios: {
          key: 'portfolio',
          options: {
            portfolio: data
          }
        }
      }
    }));
    return response;
  };

  return PortfoliosBarChartDataShortcut;
}(ShortcutBase_1.ShortcutBase);

exports.PortfoliosBarChartDataShortcut = PortfoliosBarChartDataShortcut;